<script setup lang="ts">
import { computed, onMounted, ref, watch } from "vue";
import { useConfigurationsStore } from "../../stores";

interface IsicItem {
  id: string
  code: string
  description: string
  parentId?: string
}

interface Props {
  search?: string | null
}

const props = defineProps<Props>()
const store = useConfigurationsStore();

const isicList = ref<IsicItem[]>([])

const getIsicFetch = computed(() => store.isicList);

onMounted(() => {
  store.fetchIsic();
})

watch(getIsicFetch, (dataList) => {
  if (dataList) {
    isicList.value = dataList
  }
})

watch(() => props.search, () => {
  // Implement search functionality if needed
})
</script>

<template>
  <div class="bg-white rounded border border-gray-200 overflow-hidden">
    <div class="overflow-x-auto">
      <table class="w-full text-xs">
        <thead class="bg-gray-50 sticky top-0">
          <tr>
            <th class="text-left py-3 px-4 font-semibold text-gray-700 border-b border-gray-200">
              Code
            </th>
            <th class="text-left py-3 px-4 font-semibold text-gray-700 border-b border-gray-200">
              Description
            </th>
            <th class="text-center py-3 px-4 font-semibold text-gray-700 border-b border-gray-200">
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, idx) in isicList"
            :key="idx"
            class="hover:bg-gray-50 transition"
            :class="idx % 2 === 0 ? '' : 'bg-gray-10'"
          >
            <td class="py-3 px-4 border-b border-gray-200">
              <span class="font-bold text-gray-900">{{ item.code }}</span>
            </td>
            <td class="py-3 px-4 border-b border-gray-200">
              <span class="font-medium text-gray-700">{{ item.description }}</span>
            </td>
            <td class="py-3 px-4 border-b border-gray-200 text-center">
              <button
                class="btn-sm-primary"
              >
                <i class="fa fa-pencil mr-1"></i> Edit
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<style scoped>
table {
  border-collapse: separate;
  border-spacing: 0;
}
</style>
